module.exports = __webpack_public_path__ + "static/media/grey-tr-3.8fc0f1d0.svg";